import { PageTitle } from '../../../shared/components/page-components/PageTitle';

export const FormSubmissionListPageNav = (): React.ReactElement<any, any> | null => {
    return <PageTitle>Form Submissions</PageTitle>;
};
